module.exports = __webpack_public_path__ + "img/02.f81a5176.png";